import { useEffect, useRef } from "react";
import { classNames } from "@greeter/util";
import { HTMLMotionProps, motion } from "motion/react";

import css from "./ProgressBar.module.scss";

export type ProgressBar = {
  value: number;
  target: number;

  className?: string;
  style?: React.CSSProperties;

  mode?: "strict";

  /**
   * Fires when if the target is reached.
   */
  onTargetReached?: () => void;
  /**
   * Fires when if the target is reached,
   * but  is no longer reached.
   */
  onTargetUnreached?: () => void;
} & HTMLMotionProps<"div">;
export function ProgressBar({ className, ...props }: ProgressBar) {
  const targetReached = props.value >= props.target;
  const pctCompleted = (props.value / props.target) * 100;
  const onTargetUnreachedFired = useRef<boolean>(true);
  const onTargetReachedFired = useRef<boolean>(false);
  useEffect(() => {
    if (targetReached && !onTargetReachedFired.current) {
      props.onTargetReached?.();
      onTargetUnreachedFired.current = false;
      onTargetReachedFired.current = true;
    } else if (!targetReached && onTargetReachedFired.current) {
      props.onTargetUnreached?.();
      onTargetUnreachedFired.current = true;
      onTargetReachedFired.current = false;
    }
  }, [props.value]);

  return (
    <motion.div {...classNames(css.ProgressBar, className)} {...props}>
      <div
        {...classNames(
          css.ProgressLine,
          props.mode === "strict" && props.value > props.target && css.Invalid
        )}
        style={{ width: `${Math.floor(pctCompleted)}%` }}
      />
    </motion.div>
  );
}
